import React from 'react'
import { Link } from '@morningtrain/react-navigation'
import Button from 'ui/buttons/Button'
import { Translation, Translator } from '@morningtrain/react-translations'
import { SmallCardWithImage } from 'ui/cards'
import { Collection, ForEachModel } from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'
import AdminPage from 'pages/app/AdminPage'
import { FlexGrid, PageHeader } from 'ui/layouts'
import TranslatedTitle from 'widgets/TranslatedTitle'
import * as Displays from '@morningtrain/react-displays'

export default function Index () {
  return (
    <AdminPage withGlobalDepartmentFilter={true}>
      <Translator namespace='inventory.suppliers'>

        {/* Page header */}
        <PageHeader title={<TranslatedTitle name='title' />}>
          <Link route='app.inventory.supplier.create'>
            <Button>
              <Translation name='actions.create' />
            </Button>
          </Link>
        </PageHeader>

        <Collection resourceName='inventory.supplier'>
          <SelectedDepartmentFilter />

          <FlexGrid className='mt-4 mb-12' responsive={{ xl: 4, lg: 3, md: 2 }}>
            <ForEachModel>
              <Link
                route='app.inventory.supplier.edit'
                parameters={{ inventory_supplier: 'model:id' }}
              >
                <SmallCardWithImage
                  forceColumn
                  image={<Displays.Image name='image_url' />}
                  title={<Displays.Text name='name' />}
                  subtitle={<Displays.Enum name='department_area' enum='inventory_department_area' />}
                />
              </Link>
            </ForEachModel>
          </FlexGrid>
        </Collection>

      </Translator>
    </AdminPage>
  )
}
